import { useState, useEffect } from 'react';
import axios from 'axios';

function useSession(apikey: string, url: string | undefined, baseUrl = '') {
  const [session, setSession] = useState();

  useEffect(() => {
    if (apikey && url) {
      const headers = { Authorization: 'JWT ' + apikey };
      axios
        .post(baseUrl + '/api/session', { url: url }, { headers: headers })
        .then((res) => setSession(res.data))
        .catch((err) => console.log('Session error: ' + err));
    }
  }, [session, url, baseUrl, apikey]);

  return session;
}

export default useSession;
